<template>
  <div class="info">
    <!-- 折叠面板开始 -->
    <el-collapse v-model="activeName" @change="handleChange">
      <el-collapse-item
        :name="index"
        class="collapse"
        v-for="(item, index) in Commodity"
        :key="index"
        @click.native="qieHuan(index, item)"
      >
        <template slot="title">
          <span class="txt">{{ item.commodityNameL }}</span>
          <span class="selected"
            >{{$t('Furniture.Furint.select')}}<span :class="[item.selectNum == 0 ? 'countNum' : 'selectCountNum']">{{ item.selectNum }}</span>{{ item.selectNum == 0 ?  $t('Furniture.Furint.zhuijia') : item.commodityNameL }}</span
          >
          <span class="folding" v-if="item.folding">{{$t('catalogue.down')}}</span>
          <span class="folding" v-else>{{$t('catalogue.open')}}</span>
        </template>

        <!-- id容器开始 -->
        <div id="container" @click.stop>
          <div
            class="item"
            :class="[i.num != 0 ? 'activeBox' : 'item']"
            v-for="(i, k) in item.commodityMessage"
            :key="k"
          >
            <!----------------蓝色阴影图片--------------------->
            <div class="shoadw" v-if="i.num != 0">
              <img src= "../../../../static/hook.png" alt="" />
            </div>
            <!-------------图片的背景图片------------------------>
            <img
              :src="baseUrl + i.geImgUrl ? baseUrl + i.geImgUrl : ''"
              :onerror="defaultImg"
              alt="显示错误"
            />
            <p class="title">{{ i.geName }}</p>
            <p class="bianhao">
              {{$t('Furniture.Furint.serial')}}：<span>{{ i.geNumber }}</span>
            </p>
            <p class="guige">
              {{$t('Furniture.Furint.special')}}：<span>{{ i.geSpecs }}</span>
            </p>

            <el-row class="price">
              <el-col :span="14" class="shppPrice">￥{{ i.gePrice }}</el-col>
              <el-col :span="12"
                ><el-input-number
                  v-model="i.num"
                  :step="1"
                  @change="handleSelect($event, item)"
                  :min="0"
                  :label="$t('Furniture.Furint.number')"
                ></el-input-number
              ></el-col>
            </el-row>
          </div>
        </div>
        <!-- id容器结束 -->
      </el-collapse-item>
    </el-collapse>
    <!-- 折叠面板结束 -->

    <p>{{$t('Furniture.Furint.mine')}}</p>
    <div class="tab">
      <el-table
        :data="tableData"
        style="width: 100%;border-radius:4px;"
        :header-cell-style="{
          background: '#FDC400',
            color: '#333333',
          fontSize: '14px',
          fontFamily: 'PingFangSC-Medium, PingFang SC',
          height: '36px',
        }"
      >
        <el-table-column prop="imgUrl" :label="$t('Furniture.Furint.picture')" width="200">
          <template slot-scope="scope">
            <img
              :src="baseUrl + scope.row.geImgUrl ? baseUrl + scope.row.geImgUrl : ''"
              :onerror="defaultImg"
              alt="因某种原因无法显示图片"
            />
          </template>
        </el-table-column>
        <el-table-column prop="geName" :label="$t('Furniture.Furint.exhiName')" width="180">
        </el-table-column>
        <el-table-column prop="geNumber" :label="$t('Furniture.Furint.serial')" width="200">
        </el-table-column>
        <el-table-column prop="geSpecs" :label="$t('Furniture.Furint.special')" width="220">
        </el-table-column>
        <el-table-column prop="gePrice" :label="$t('Furniture.Furint.zero')" width="190">
        </el-table-column>
        <el-table-column prop="totalSum" :label="$t('Furniture.Furint.rentNum')" width="150">
        </el-table-column>

        <el-table-column prop="boothNum" :label="$t('Furniture.Furint.exhinumb')" width="180">
        </el-table-column>

        <el-table-column prop="orderStatus"  :label="$t('Furniture.Furint.states')"> </el-table-column>
      </el-table>
    </div>

    <!-- 轮播子元素 -->
     <div class="lunBoYinYing">

        <div class="settlement">
      <div class="live" v-if="flag && listItems.length != 0">
        <div class="select">已选中{{ counter }}{{$t('Furniture.Furint.zhuijia')}}</div>
        <!--<div class="exhibitorsLive" id="swiper-tt">
           <swiper :options="swiperOption" ref="hits" :auto-update="true">
            <swiper-slide v-for="(item, index) in listItems" :key="index"
            >
              <div class="img">
                <img
                  :src="item.geImgUrl ? item.geImgUrl : ''"
                  :onerror="defaultImg"
                  alt="显示错误"
                />
                <div class="btn">
                  <el-input-number
                    v-model="item.collectStatus"
                    @change="handlNum($event, item)"
                    :min="1"
                    label="描述文字"
                  ></el-input-number>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
      </div> -->

        <div class="swiperContainer">
          <div
            class="swiperBox"
            v-for="(item, index) in listItems"
            :key="index"
          >
            <div class="img">
              <img
                :src="baseUrl +item.geImgUrl ? baseUrl +item.geImgUrl : ''"
                :onerror="defaultImg"
                alt="显示错误"
              />
              <div class="btn">
                <el-input-number
                  v-model="item.num"
                  @change="handlNum($event, item)"
                  :min="0"
                  label="描述文字"
                ></el-input-number>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-------------大于1的时候说明只有一个展位------------------->

      <span class="exAddress" v-if="options.length >1">
        {{$t('Furniture.selectNumb')}}
        <el-select v-model="boothId" :placeholder="$t('common.select')" >
          <el-option
            v-for="item in options"
            :key="item.boothNum"
            :label="item.boothNum"
            :value="item.boothNum"
          >
          </el-option>
        </el-select>
      </span>
      <!--------------------------------------------------------------->

      <span @click="close()" class="furniture"
        >{{ selectCount }}{{$t('Furniture.Furint.zhuijia')}}
        <i :class="[flag ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"></i>
      </span>

      <div class="money">
          {{$t('Furniture.titleRent')}}<span class="totalPrice">￥{{ totalRent }}</span>
      </div>

      <el-button type="primary" class="bn" @click="OpenSure()">{{ $t('common.submit') }}</el-button>
    </div>



     </div>

    <!-----------------------物品租用清单----------------------------->
    <el-dialog
      :title="$t('Furniture.Furint.title')"
      :visible.sync="sureTab"
      :before-close="CloseSure"
      width="fit-content"
      :close-on-click-modal="false"
    >
      <div class="box">
        <div class="tabb">
          <table>
            <div class="head">
              <thead>
                <tr>
                  <th class="tableImg">{{$t('Furniture.Furint.picture')}}</th>
                  <th>{{$t('Furniture.Furint.exhiName')}}</th>
                  <th>{{$t('Furniture.Furint.serial')}}</th>
                  <th>{{$t('Furniture.Furint.special')}}</th>
                  <th>{{$t('Furniture.Furint.zero')}}</th>
                  <th class="loanNum">{{$t('Furniture.Furint.rentNum')}}</th>
                  <th>{{$t('Furniture.Furint.count')}}</th>
                  <th class="option">{{$t('Furniture.Furint.operate')}}</th>
                </tr>
              </thead>
            </div>

            <div class="over">
              <tbody>
                <tr v-for="(item, index) in listItems">
                  <td>
                    <img
                      :src="baseUrl +item.geImgUrl ? baseUrl + item.geImgUrl : ''"
                      :onerror="defaultImg"
                    />
                  </td>

                  <td>{{ item.geName }}</td>
                  <td>{{ item.geNumber }}</td>
                  <td>{{ item.geSpecs }}</td>
                  <td>{{ item.gePrice }}</td>
                  <td class="leaseCount">
                    <div v-if="item.falg">{{ item.num }}</div>
                    <div v-else>
                      <el-input-number
                        v-model="item.num"
                        @change="handleChange(item)"
                        :min="1"
                        :max="100"
                        label="描述文字"
                      ></el-input-number>
                    </div>
                  </td>
                  <td>{{ item.gePrice * item.num }}</td>
                  <td>
                    <div class="btnGroup">
                      <span v-if="item.falg" @click="rowEdit(item, index)"
                        ><img
                          class="iconImg"
                          src="../../../../static/edit.png"
                          alt=""
                        />{{$t('common.edit')}}</span
                      >
                      <span v-else @click="rowSave(item, index)"
                        ><img
                          class="iconImg"
                          src="../../../../static/save.png"
                          alt=""
                        />{{$t('common.save')}}</span
                      >
                      <span @click="rowDelete(item,index)"
                        ><img
                          class="iconImg"
                          src="../../../../static/del.png"
                          alt=""
                        />{{$t('common.delete')}}</span
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </div>
          </table>
        </div>

        <div class="computed">
          <span v-if="boothNum != ''">{{$t('homepage.positionNumber')}}：{{ boothNum }}</span>
          <span class="selectex"
            >{{$t('Furniture.Furint.select')}} <span class="counter">{{ counter }}</span
            >{{$t('Furniture.Furint.zhuijia')}}</span
          >
          <span class="leaseMoney"
            >{{$t('Furniture.titleRent')}}￥ <span class="totalPrice">{{ totalPrice }}</span></span
          >
          <span
            ><el-button type="primary" @click="sureSumit()"
              >{{$t('dialog.sure')}}</el-button
            ></span
          >
        </div>
      </div>
    </el-dialog>
    <!--------------------------------------------------------------->
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import  { forMat } from '..//../../../../utils/common.js'
import {
  getGreenList,
  getexAddress,
  sumitEXMsg,
  lease,
} from "../../../../../api/green.js"; //导入展具列表函数

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
        baseUrl: forMat(),
      activeName: [], //默认打开第一个面板
      chairNum: 0, //已选择的商品数量
      //商品信息
      Commodity: [],
      //我租赁的绿植花卉
      tableData: [],

      //swiper 初始化
      // swiperOption: {
      //   pagination: ".swiper-pagination",
      //   loop: true,
      //   slidesPerView: 0,
      //   spaceBetween: 0,
      //   observer: true,
      //   observeParents: true,
      //   autoplay: {
      //     delay: 9999999900,
      //     stopOnLastSlide: false,
      //     disableOnInteraction: false,
      //   },
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true,
      //   },
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev",
      //   },
      // },
      //折叠显示
      flag: false,

      //存放选中的数组
      selectArr: [],

      //存放选中的数据
      listItems: [],

      //确认提交面板
      sureTab: false,

      options: [], //展位集合

      boothId: "", //尾部下拉框绑定的展位号
      boothNum: "", //确认单中绑定的展位号
    };
  },
  methods: {
    handleChange(val) {},

    //商品的步进器触发函数
    handleSelect(value, item) {
      let count = 0;
      //  console.log("当前的item是:", item);

      item.commodityMessage.forEach((i) => {
        count += i.num;
        i.num != 0 ? (i.shadow = true) : (i.shadow = false); //判断阴影显示
      });

      item.selectNum = count;
      this.settlement(); //步进器触发的时候调用此函数
    },

    //循环遍历数据
    settlement() {
      this.listItems = [];
      this.Commodity.forEach((item) => {
        item.commodityMessage.forEach((i) => {
          if (i.num !== 0) {
            this.listItems.push(i);
          }
        });
      });
    },

    handleCh(val) {
      //   console.log(val);
    },



    //阴影轮播图的步进器选择变化函数
    handlNum(value, item) {
      const id = item.id;  //选中项的,Id
       //工具函数进行处理,在阴影中勾选步进器改变商品数量的时候,将还是那个品栏目中的数量也改变
       this.iteration(this.Commodity); //进行格式化处理
      //判断当前的数量是否等于0
      if (item.num == 0) {
        let i = 0;  
        //循环选中的数组,
        this.listItems.forEach((item, index) => {

           i = index;  //每次都把当前的索引赋值给i
          if (item.id == id) {
                
              //  return false;
               this.listItems.splice(i,1);
          }
        });
      }

    },


    //工具函数进行处理
    iteration(arr) {
      arr.forEach((item) => {
        let count = 0;
        item.commodityMessage.forEach((i) => {
          count += i.num;
        });
        item.selectNum = count;
      });
    },





    //控制阴影轮播的数据
    close() {
      this.flag = !this.flag;
    },
    //打开提交按钮,弹出确认框
    OpenSure() {
       if (this.options.length > 1) {
        this.boothId == ""? this.$message({ message:  this.$t('Furniture.Furint.dialglog'), type: "warning" }): (this.sureTab = true);

        // console.log('打开提交按钮',this.boothId);

        this.boothNum = this.boothId;
        // console.log('赋值后的展位信息',this.boothNum)
      } else {
        this.sureTab = true;
        // console.log('打开提交按钮',this.options)
        const id = this.options[0].boothNum; //拿到展位号

        this.boothNum = id;
      }


    },
    //关闭确认框
    CloseSure() {
      this.sureTab = false;
    },
    //-------------g购物车确定清单----------------------
    editor(value) {
      this.$nextTick(() => {
        if (value.num < 1) {
          this.$set(value, "num", 0);
        } else {
          const count = value.num++;
          this.$set(value, "num", count);
        }
      });
    },
    //------------编辑行元素----------------------
    rowEdit(item, index) {
      item.falg = !item.falg; //没有flag
    },
    //----------保存航元素------------------------
    rowSave(item, index) {
      item.falg = !item.falg; //没有flag
    },

    //删除行的时候,循环遍历一下商品列表,然后
    rowDelete(item, index) {
             const shopName = item.geName;
             this.changeShopList(shopName,this.Commodity);
            this.listItems.splice(index, 1);
               this.iteration(this.Commodity); //进行格式化处理
    },

     //循环删除Comm
     changeShopList(clickName,arr){
         const name = clickName;
          arr.forEach((item)=>{
                //item是对象
               item.commodityMessage.forEach((i)=>{
                     if (i.geName == name) {
                          i.num = 0;
                          return false;
                      }
               })
          })
     },

    async getExhibitionList() {
      let lang=localStorage.getItem('lang')
      
      let { data } = await getGreenList(lang);
      let exAddress = await getexAddress();
      this.Commodity = this.merge(data.data.exhibition);
      this.options = [...exAddress.data.data]; //获取展位信息

      // console.log("展位信息是:", this.options);
      this.Commodity.forEach((item) => {
        this.tool(item);
      });
    },
    //获取我的租赁展品
    async getMylease() {
      let obj = {};
      obj.type = "展具";
      let { data } = await lease(obj);
      // console.log("租赁的展具",data);
      this.tableData = data.data;
      //console.log("**********", this.tableData);
    },

    //------------工具函数--------------
    merge(exhibition) {
      let arr = [];
      Object.keys(exhibition).forEach((key) => {
        let itemObj = {};
        itemObj.selectNum = 0; //添加选中类型数量的属性
        itemObj.folding = false; //添加标志位
        itemObj.commodityMessage = exhibition[key];
        itemObj.num = 0; //总共的选中的展具数量
        exhibition[key] = this.loopItem(exhibition[key]);
        //把数据推进数组中
        arr.push(itemObj);
      });
      //返回处理后的数据

      return arr;
    },

    //循环列表子项,初始化每个商品选中的数量  -----------工具函数
    loopItem(item) {
      //item数数组类型
      let arr = [...item];
      item.forEach((item) => {
        item.num = 0;
        item.falg = true;
      });
      return arr;
    },

    //确认本次提交展具租赁清单的提交函数
    async sureSumit() {
      let sumitMsg = {};

      sumitMsg.ids = this.listItems;
      let arr = [];
      this.listItems.map((item) => {
        let obj = {};
        obj.id = item.id;
        obj.totalSum = item.num;
        arr.push(obj);
      });
      sumitMsg.ids = arr;

      let id;
      this.options.forEach((item)=>{
        if (this.boothId==item.boothNum) {
            id=item.id
            //console.log('输出转换的id是',id)
        }
      })
      if (this.boothId != "") {
        sumitMsg.boothId = id;

      } else {
        //使用默认的id
        sumitMsg.boothId = this.options[0].id;
      }

      let msg = await sumitEXMsg(sumitMsg);
      if (msg.data.code == 200n) {
        this.$message({ message: this.$t('dialog.submitSuccess'), type: "success" });
        this.sureTab = false; //关闭提交弹框
        this.listItems = [];
        //重新掉用接口刷新数据
        this.getExhibitionList();
        this.getMylease();
      } else {
        this.$message.error( this.$t('Furniture.Furint.dialglog1'));
      }
    },
    //展位号处理函数
    boothProcessing(boothId, options) {
      let id = null;
      options.forEach((item) => {
        if (item.id == boothId) {
          id = item.boothNum;
        }
      });
      return id; //返回
    },

    qieHuan(index, item) {
      //   console.log("数据切换");
      item.folding = !item.folding;
    },
    //工具函数
    tool(item) {
      if (item.commodityMessage[0].geProductType == "Table") {
        item.commodityNameL = this.$t('Furniture.Furint.desk');
      } else if (item.commodityMessage[0].geProductType == "chair") {
        item.commodityNameL = this.$t('Furniture.Furint.chair');
      } else if (item.commodityMessage[0].geProductType == "electric") {
        item.commodityNameL = this.$t('Furniture.Furint.eletrirc');
      } else if (item.commodityMessage[0].geProductType == "other") {
        item.commodityNameL = this.$t('Furniture.Furint.other');
      } else if (item.commodityMessage[0].geProductType == "sofa") {
        item.commodityNameL = this.$t('Furniture.Furint.sofa');
      } else if (item.commodityMessage[0].geProductType == "standard") {
        item.commodityNameL = this.$t('Furniture.Furint.biaotan');
      } else if (item.commodityMessage[0].geProductType == "suit") {
        item.commodityNameL =this.$t('Furniture.Furint.setMea');
      } else if (item.commodityMessage[0].geProductType == "teaTable") {
        item.commodityNameL =this.$t('Furniture.Furint.tea');
      }
    },
  },
  computed: {
    //默认商品显示底图
    defaultImg() {
      return (
        'this.src ="' + require("../../../../static/占位-展品-列表.png") + '"'
      );
    },

    //确认单计算总价
    totalPrice() {
      let totalprice = 0;
      this.listItems.forEach((item, index) => {
        totalprice += item.gePrice * item.num;
      });
      return totalprice;
    },
    //确认单计算数量
    counter() {
      let counter = 0;
      this.listItems.forEach((item, index) => {
        counter += item.num;
      });
      return counter;
    },

    //阴影计算总价
    totalRent() {
      let totalprice = 0;
      this.listItems.forEach((item, index) => {
        totalprice += item.num * item.gePrice;
      });
      return totalprice;
    },

    //尾部已选好中家具数量
    selectCount() {
      let count = 0;
      this.listItems.forEach((item, index) => {
        count += item.num;
      });
      return count;
    },
  },

  //页面加载,执行钩子函数获取列表数据
  created() {
    this.getExhibitionList();
    this.getMylease();
  },
};
</script>
<style scoped lang="scss">
.info {
  box-sizing: border-box;
  position: relative;
  .selected {
    position: absolute;
    right: 117px;
    letter-spacing: 2px;
  }
  .folding {
    position: absolute;
    right: 35px;
    width: fit-content;
  }
  #container {
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 252px);
    grid-gap: 10px;
  }
  // item变化
  .item {
    border: 1px solid #e0e0e0;
    margin-top: 15px;
    padding-bottom: 15px;
    position: relative;

    //------------------------------------------------------------------------
    .shoadw {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 187px;
      background: rgba(0, 111, 184, 0.5);
      text-align: center;
      line-height: 187px;
      img {
        width: 33px;
        height: 25px;
        display: inline;
      }
    }

    //------------------------------------------------------------------------

    img {
      width: 100%;
      height: 187px;
    }
    .title {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 800;
      color: #333333;
      line-height: 19px;
      padding-left: 17px;
      box-sizing: border-box;
      padding-top: 17px;
    }

    .bianhao {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 19px;
      padding-left: 17px;
      box-sizing: border-box;
      padding-top: 8px;
    }
    .guige {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 19px;
      padding-left: 17px;
      box-sizing: border-box;

      padding-top: 8px;
    }
    .price {
      display: flex;
      justify-content: space-between;
      padding-left: 17px;
      box-sizing: border-box;
      padding-top: 8px;
      margin-top: 1px;
    }
  }
  // item不变

  p {
    padding-top: 52px;
    padding-bottom: 9px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
  }
  .tab {
    border-top: 1px solid #e9e9e9;
    height: fit-content;
    padding-top: 20px;
    img {
      width: 104px;
      height: 78px;
    }
  }

  .lunBoYinYing{
     z-index: 9900;
  }

  .settlement {
    position: relative;
    display: flex;
    height: 30px;
    padding-top: 20px;
    .furniture {
      i {
        padding-left: 10px;
      }
    }
    .money {
      display: flex;
      position: relative;
      left: 25px;
      .totalPrice {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 800;
        color: #ff190c;
        margin-left: 6px;
      }
    }
    .bn {
      position: absolute;
      right: 0px;
    }
  }
}
.selectCountNum {
  color: red;
}
.countNum {
  color: black;
}
</style>
<style scoped>
.el-input-number {
  width: 91px;
  height: 24px;
  line-height: 24px;
}
.el-input-number >>> .el-input__inner {
  line-height: 24px !important;
  height: 24px !important;
  padding: 0px;
  border-radius: 3px;
}
.el-input-number >>> .el-input-number__decrease,
.el-input-number__increase {
  width: 24px !important;
  height: 22px !important;
}
.el-input-number >>> .el-input-number__increase {
  width: 24px !important;
  height: 22px !important;
}
.collapse >>> .el-collapse-item__header {
  border-bottom: 1px solid #006fb8 !important;
}
.settlement >>> .el-collapse-item__arrow {
  float: left;
  position: absolute;
  left: 90px;
}
.el-button--primary {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  width: 76px;
  height: 28px;
  line-height: 0px;
  background-color: #006fb8;
}
.collapse >>> .el-collapse-item__header {
  position: relative;
}
.el-collapse-item >>> .el-collapse-item__wrap {
  border-bottom: none !important;
}
.info >>> .el-collapse-item__content {
  padding-top: 15px !important;
}
.el-dialog__wrapper >>> .el-dialog__header {
  padding: 15px 20px 10px;
  background: #006fb8;
}
.el-dialog__wrapper >>> .el-dialog__title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.el-dialog__wrapper >>> .el-dialog__close {
  color: #ffffff;
}
.el-dialog__wrapper >>> .el-dialog__body {
  padding: 20px 20px 0px 20px;
}







.el-input-number >>> .el-input-number__decrease,
.el-input-number__increase {
  width: 24px !important;
  height: 22px !important;
  background-color: transparent !important;

}
.el-input-number >>> .el-input-number__increase {
  width: 24px !important;
  height: 22px !important;
  background-color: transparent !important;
}
.el-button--primary {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  height: 28px;
  line-height: 0px;
  background-color: #006fb8;
  text-align: center;
}
/* 下拉框样式修改 */
.el-select >>> .el-input__inner {
  height: 28px !important;
}
.el-select >>> .el-input__icon {
  line-height: 28px !important;
}
.row >>> .el-input__inner {
  width: 130px !important;
  height: 28px !important;
}
.el-table >>> .cell{
    font-weight: 600;
}


.el-input-number >>> .el-input-number__increase{
    /* border-left: transparent !important; */
    border-left: 1px solid #d7dadf !important; 
}
.el-input-number >>> .el-input-number__decrease{
    /* border-right: transparent !important; */
    color: #d7dadf;  
    /* border-right:1px solid #d7dadf !important;  */
}

</style>
<style lang="scss" scoped>
.live {
  width: 100%;
  height: fit-content;
  background-color: rgba(29, 21, 21, 0.45);
  position: absolute;
  top: -300px;
   z-index: 5;
  .select {
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    padding-left: 25px;
    padding: 20px;
  }
  .img {
    width: 231px;
    margin: 0 auto;
    
    img {
      width: 231px;
      height: 173px;
    }
    .btn {
      display: flex;
      justify-content: center;
      padding-top: 10px;
    }
  }
  .exhibitorsLive {
    width: 100%;
  }
}
</style>
<style scoped>
/*-------------------轮播图样式修改---------------------------*/
.swiper-slide {
  width: 310px;
  padding-bottom: 60px;
}
.el-input-number {
  width: 91px;
  height: 24px;
  line-height: 24px;
}
.el-input-number >>> .el-input__inner {
  line-height: 24px !important;
  height: 24px !important;
  padding: 0px;
  border-radius: 3px;
}
.el-input-number >>> .el-input-number__decrease,
.el-input-number__increase {
  width: 24px !important;
  height: 22px !important;
}
.el-input-number >>> .el-input-number__increase {
  width: 24px !important;
  height: 22px !important;
}
.exhibitorsLive >>> .swiper-wrapper {
  left: 0px;
}
/* 改变轮播图的箭头 */
.live >>> .swiper-button-prev {
  height: 20px;
  left: -1px;
  background-image: url("../../../../static/icon-arrow-left.png");
}
.live >>> .swiper-button-next {
  height: 20px;
  right: -1px;
  background-image: url("../../../../static/icon-arrow-right.png");
}
</style>
<style scoped lang="scss">
.box {
  border-radius: 2px 2px 0px 0px;
  .tabb {
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
      font-family: " PingFangSC-Medium, PingFang SC";
      thead {
        background-color: #fdc400;
        border-radius: 10px;
        table-layout: fixed;

        tr {
          height: 36px;
         // color: rgba(255, 255, 255, 0.85);
          color:#333333;
          width: 100%;
          th {
            box-sizing: border-box;
            height: 36px;
            width: 135px;
            text-align: center;
          }
          .tableImg {
            text-align: left;
            padding-left: 20px;
          }
          .loanNum {
            width: 101px;
          }
          .option {
            padding-left: 20px;
            text-align: left;
          }
        }
      }
      tbody {
        tr {
          border-bottom: 1px solid #e8e8e8;
          td {
            text-align: center;
            width: 132px;
            img {
              width: 104px;
              height: 78px;
              margin: 10px 0px;
            }
            span {
              color: #006fb8;
              margin: 0px 5px;
            }
          }
          &:nth-child(even) {
            background-color: #f6f6f7;
          }
        }
      }

      .over {
        height: 480px;
        min-height: 480px;
        overflow: auto;
      }

      .leaseCount {
        width: 101px;
        div {
          margin: 0 auto;
          text-align: center;
          width: 92px;
        }
      }
    }
  }

  .computed {
    //margin: 34px 26px 0px 26px;
    height: 46px;
    background-color: #ffffff;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 1px solid rgba(0, 0, 0, 0.09);
    .selectex {
      margin-right: 26px;
      margin-left: 30px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      .counter {
        color: red;
        font-weight: 600;
        margin: 0px 5px;
      }
    }
    .leaseMoney {
      margin-right: 69px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      .totalPrice {
        color: red;
        font-weight: 600;
        margin: 0px 5px;
      }
    }
    span {
      font-weight: 600;
    }
  }
}
.exAddress {
  margin-right: 30px;
}
.shppPrice {
  font-weight: 600;
}

.btnGroup {
  display: flex;
}
.btnGroup span {
  display: flex;
  align-items: center;
  .iconImg {
    width: 16px !important;
    height: 16px !important;
    margin-right: 2px !important;
  }
}
</style>
<style scoped>
/* -------------步进器相关函数-------------- */
.el-input-number {
  width: 91px;
  height: 24px;
  line-height: 24px;
}
.el-input-number >>> .el-input__inner {
  line-height: 24px !important;
  height: 24px !important;
  padding: 0px;
  border-radius: 3px;
}
.el-input-number >>> .el-input-number__decrease,
.el-input-number__increase {
  width: 24px !important;
  height: 22px !important;
}
.el-input-number >>> .el-input-number__increase {
  width: 24px !important;
  height: 22px !important;
}
.el-button--primary {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  height: 28px;
  line-height: 0px;
  background-color: #006fb8;
  text-align: center;
}
/* 下拉框样式修改 */
.el-select >>> .el-input__inner {
  height: 28px !important;
}
.el-select >>> .el-input__icon {
  line-height: 28px !important;
}
.row >>> .el-input__inner {
  width: 130px !important;
  height: 28px !important;
}

/* ------------表格样式穿透------------------- */
.el-dialog__wrapper >>> .el-dialog {
  width: 1120px;
}

.el-table >>> .cell {
  font-weight: 600;
}
</style>
<style scoped lang="scss">
.swiperContainer {
  display: flex;
  justify-content: flex-start;
  overflow-x: scroll;
  padding: 0px 20px;
  .swiperBox {
    margin-right: 30px;
    padding-bottom: 20px;
  }
}

.activeBox {
  border: 1px solid #006fb8 !important;
  margin-top: 15px;
  padding-bottom: 15px;
  position: relative;

  //------------------------------------------------------------------------
  .shoadw {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 187px;
    background: rgba(0, 111, 184, 0.5);
    text-align: center;
    line-height: 187px;
    img {
      width: 33px;
      height: 25px;
      display: inline;
    }
  }

  //------------------------------------------------------------------------

  img {
    width: 100%;
    height: 187px;
  }
  .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 800;
    color: #333333;
    line-height: 19px;
    padding-left: 17px;
    box-sizing: border-box;
    padding-top: 17px;
  }

  .bianhao {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 19px;
    padding-left: 17px;
    box-sizing: border-box;
    padding-top: 8px;
  }
  .guige {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 19px;
    padding-left: 17px;
    box-sizing: border-box;

    padding-top: 8px;
  }
  .price {
    display: flex;
    justify-content: space-between;
    padding-left: 17px;
    box-sizing: border-box;
    padding-top: 8px;
    margin-top: 1px;
  }
}

//  table tr:first-child th:first-child {
//         border-top-left-radius: 4px;

//     }

//     table tr:first-child th:last-child {
//         border-top-right-radius: 4px;
//     }
//     table tr:last-child td:first-child {
//         border-bottom-left-radius: 4px;
//     }

//     table tr:last-child td:last-child {
//         border-bottom-right-radius: 4px;
//     }
</style>
